/** JSON with object keys sorted, so equal values serialize identically whatever their key order. */
export const stableJSON = (value: any): string => JSON.stringify(value, (_, item) =>
    item && typeof item === 'object' && !Array.isArray(item)
        ? Object.fromEntries(Object.keys(item).sort().map(key => [key, item[key]])) : item);
